import './pdr-field.css'
import { PdrFieldElement } from './PdrFieldElement'

customElements.define('pdr-field', PdrFieldElement)
